<style scoped lang="scss" type="text/scss">
    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }

    .uploader-container {
        position: relative;

        .uploading-icon-container {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;

            .loading-wrap {
                display: flex;
                flex-direction: column;
                align-items: center;

                img {
                    width: 3rem;
                    height: 3rem;
                    animation: spin 3s ease infinite;
                }

                span {
                    color: #CCC;
                    font-size: .75rem;
                }
            }
        }
    }
</style>

<template>
    <el-upload
            class="uploader-container"
            ref="uploadComponent"
            list-type="picture-card"
            :file-list="validFileList"
            :on-change="handleChange"
            :before-upload="beforeUpload"
            :show-file-list="true"
            :with-credentials="false"
            :action="''"
            :multiple="true"
            :auto-upload="autoUpload"
            :accept="accept"
    >
        <i slot="default" class="el-icon-plus"></i>
        <div slot="file" slot-scope="{file}">
            <img
                class="el-upload-list__item-thumbnail"
                :src="file.url" alt=""
            >
            <span class="el-upload-list__item-actions">
        <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
        >
          <i class="el-icon-zoom-in"></i>
        </span>
        <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleDownload(file)"
        >
          <i class="el-icon-download"></i>
        </span>
        <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
        >
          <i class="el-icon-delete"></i>
        </span>
      </span>
        </div>
<!--        <slot></slot>-->
<!--        <shadow-placeholder class="uploading-icon-container" :circular="circular" v-if="uploading">-->
<!--            <div class="loading-wrap">-->
<!--                <img src="./loading.png" alt="">-->
<!--                <span>上传中...</span>-->
<!--            </div>-->
<!--        </shadow-placeholder>-->
    </el-upload>
</template>

<script>
    import {FileHelper, generateRandomFileName, ImageHelper} from '../../utils/file/index';
    import STATUS from './status';
    import ShadowPlaceholder from '../../components/shadow-placeholder/index';

    export default {
        name: '',
        components: {
            ShadowPlaceholder
        },
        props: {
            value: {
                default () {
                    return [];
                }
            },
            autoUpload: {
                type: Boolean,
                default: false
            },
            isImage: {
                type: Boolean,
                default: false
            },
            limitTypes: {
                type: Array,
                default () {
                    return [];
                }
            },
            limitSize: {
                type: Number,
                default: null
            },
            limitWidth: {
                type: Number,
                default: null
            },
            limitHeight: {
                type: Number,
                default: null
            },
            circular: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                uploadingPromise: null,
                validFileList: [],
                uploading: false
            };
        },
        computed: {
            signature () {
                return this.$store.state.file.signature;
            },
            accept () {
                return this.limitTypes.join(',');
            },
            fileHelper () {
                let fileHelper = null;
                if (this.isImage) {
                    fileHelper = new ImageHelper(this.limitTypes, this.limitSize, this.limitWidth, this.limitHeight);
                } else {
                    fileHelper = new FileHelper(this.limitTypes, this.limitSize);
                }
                return fileHelper;
            }
        },
        methods: {
            obtainValidSignature () {
                return new Promise((resolve, reject) => {
                    this.$store.dispatch('file/loadSignature').then(response => {
                        return resolve(this.signature);
                    }).catch(error => {
                        return reject(error);
                    });
                });
            },
            upload () {
                this.$refs.uploadComponent.submit();
            },
            trigger () {
                this.$refs.uploadComponent.$el.firstChild.click();
            },
            sync (file) {
                this.$emit('input', file);
            },
            uploadSuccess (response) {
                // Promise 钩子，勿删
            },
            uploadFail (error) {
                // Promise 钩子，勿删
            },
            async handleChange (file, fileList) {
                if (null === file || undefined === file) return;

                const status = file.status;
                if (STATUS.READY === status) {
                    // 在文件被添加时，进行文件类型、大小、图片长宽等检测
                    const isValid = await this.fileHelper.isValid(file.raw);
                    this.uploading = false;
                    if (isValid) {
                        this.sync(file);
                        this.$emit('on-add', file);
                    } else {
                        this.validFileList = [];
                        const errorMessages = this.fileHelper.errorMessages;
                        if (errorMessages.length > 0) {
                            this.$tip(errorMessages[0]);
                        }
                        this.$emit('file-invalid', this.fileHelper.errorMessages);
                    }
                }
            },
            beforeUpload (file) {
                // 在文件开始上传时，抛出上传事件，并赋值 Promise
                this.uploading = true;
                return this.obtainValidSignature().then(signature => {
                    const randomFileName = generateRandomFileName(file.name);
                    const randomFileUri = `${signature.path}${randomFileName}`;
                    file.randomName = randomFileName;
                    file.path = signature.path;
                    const extraParams = {
                        key: randomFileUri,
                        policy: signature.policy,
                        OSSAccessKeyId: signature.access_id,
                        success_action_status: 200,
                        signature: signature.signature
                    };
                    this.uploadingPromise = new Promise((resolve, reject) => {
                        this.uploadSuccess = resolve;
                        this.uploadFail = reject;
                    });
                    this.$store.dispatch('file/upload', {
                        ...extraParams,
                        url: signature.host,
                        file
                    }).then(response => {
                        this.handleSuccess(response, file);
                    }).catch(error => {
                        this.handleError(error, file);
                    });
                    this.$emit('on-uploading', this.uploadingPromise);
                    this.sync(file);
                    // 不使用 upload 组件的上传机制，而是自己实现
                    return Promise.reject();
                }).catch(_ => {
                    return Promise.reject();
                });
            },
            handleSuccess (response, file) {
                const fileRaw = file;
                this.uploadSuccess({
                    name: fileRaw.name,
                    random_name: fileRaw.randomName,
                    path: fileRaw.path,
                    size: fileRaw.size,
                    finish_callback: () => {
                        this.uploading = false;
                    }
                });
                this.sync(file);
            },
            handleError (error, file) {
                this.uploading = false;
                this.uploadFail(error);
                this.sync(file);
            }
        }
    };
</script>
